namespace UUri {
  // Match all schemes including https://, mailto:, tel:
  export const hasScheme = (uri: string) => /^\w+:/.test(uri);

  export const hasOrigin = (uri: string, origin: string) =>
    uri === origin || uri.startsWith(`${origin}/`);

  const pathBase = "https://same-origin.invalid";

  export const toSameOriginPath = (
    uri: string | null | undefined,
    origin?: string
  ) => {
    if (uri && origin && hasOrigin(uri, origin))
      uri = uri.slice(origin.length) || "/";
    if (!uri || !/^\/(?![/\\])/.test(uri)) return;

    let url: URL;
    try {
      url = new URL(uri, pathBase);
    } catch {
      return;
    }

    if (url.origin !== pathBase || url.pathname.startsWith("//")) return;

    return `${url.pathname}${url.search}${url.hash}`;
  };
}

export default UUri;
